<script>
import TwCard from '@/components/generic/tw-card.vue'
import FundraiserPublishButton from '@/components/fundraisers/fundraiser-publish-button.vue'
import TwTransitionContainer from '@/components/generic/tw-transition-container.vue'
import TwContainer from '@/components/generic/tw-container.vue'
import { useFundraiserPublicStore } from '@/stores/fundraiserPublic.js'
import TwButton from '@/components/generic/tw-button.vue'
import loggedInUserMixin from '@/mixins/loggedInUserMixin.js'
import TwGridDual from '@/components/generic/tw-grid-dual.vue'

export default {
  name: 'FundraiserTopHeader',
  components: { TwGridDual, TwButton, TwContainer, TwTransitionContainer, FundraiserPublishButton, TwCard },
  mixins:[loggedInUserMixin],
  props: {
    fundraiser: {
      type: Object,
      required: true
    }
  },
  computed: {
    canPublish() {
      if(this.loggedInUser) {
        return (this.loggedInUser.admin || this.fundraiser.owner_user_id === this.loggedInUser.id)
      }
      return false
    }
  },
  methods: { useFundraiserPublicStore }
}
</script>

<template>
  <div class="bg-white pt-3 pb-3">
    <tw-container class="max-w-[1360px]">
      <tw-transition-container>
        <tw-card v-if="canPublish && !fundraiser.published" class="shadow-none bg-amber-100 mb-5 flex flex-col md:flex-row gap-5 justify-between md:items-center w-full">
          <p>This campaign is not published yet. It will not be visible to the public until you publish it. Only you can see it for now. </p>
          <fundraiser-publish-button :fundraiser="fundraiser" @fundraiser-published="useFundraiserPublicStore().itemPatchState($event)" />
        </tw-card>
      </tw-transition-container>
      <div class="flex justify-between items-center gap-4">
        <div v-if="fundraiser.logo_url">
          <router-link to="/">
            <img :src="fundraiser.logo_url" class="max-h-12 md:max-h-14 max-w-[320px] md:max-w-auto" :alt="fundraiser.title + ' logo'">
          </router-link>
        </div>

        <div v-if="loggedInUser && canPublish" class="flex flex-row gap-3 whitespace-nowrap">
          <tw-button variant="secondary" :to="{name: 'FundraiserDetailsPage', params: { fundraiserId: fundraiser.id} }">
            Edit Campaign
          </tw-button>
        </div>
        <div v-if="!loggedInUser" class="flex flex-row gap-3 whitespace-nowrap">
          <tw-button v-if="fundraiser.settings && fundraiser.settings.enable_supporters && !fundraiser.settings.lock_joining" variant="amber" :to="{ name: 'FundraiserPublicJoinPage', params: { fundraiserId: fundraiser.id } }" class="hidden md:flex">
            Join Campaign
          </tw-button>
          <tw-button :to="{name: 'Login'}" variant="secondary">
            Login
          </tw-button>
        </div>
      </div>
      <tw-button v-if="fundraiser.settings && fundraiser.settings.enable_supporters && !fundraiser.settings.lock_joining" variant="amber" :to="{ name: 'FundraiserPublicJoinPage', params: { fundraiserId: fundraiser.id } }" class="grow mt-3 md:hidden" block>
        Join Campaign
      </tw-button>
    </tw-container>
  </div>
</template>

<style scoped>

</style>
